var map = {
	"./R__Migrate_graph_to_branch.coffee": 2022,
	"./U0__Remove_SizeParams.coffee": 2023,
	"./V0__Bootstrap.coffee": 2024,
	"./V1_10__Add_GraphConfig.coffee": 2025,
	"./V1_1__Add_merge_request.coffee": 2044,
	"./V1_2__Migrate_old_services.coffee": 2045,
	"./V1_3__Migrate_importExcel_to_import.coffee": 2046,
	"./V1_4__Migrate_upload_transformations_file.coffee": 2047,
	"./V1_5__Migrate_AppView_to_GraphView.coffee": 2048,
	"./V1_6__Protect_config_branch_by_default.coffee": 2049,
	"./V1_7__Add_NodeSizeParams.coffee": 2050,
	"./V1_8__Add_RelationSizeParams.coffee": 2051,
	"./V1_9__Add_IdFormat.coffee": 2052,
	"./V1__Bootstrap.coffee": 2053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2021;